// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const config = {
  apiKey: "AIzaSyAvB-wrQk21_vGrYdrsfwYY4zFqlOgyqqQ",
  authDomain: "ma-ashiyaat-server.firebaseapp.com",
  projectId: "ma-ashiyaat-server",
  storageBucket: "ma-ashiyaat-server.appspot.com",
  messagingSenderId: "902681241586",
  appId: "1:902681241586:web:b68bb188667ad69785ed6b",
  measurementId: "G-V2R4W9NNBQ"
};